// extracted by mini-css-extract-plugin
export default {"General":"General_General__ySmPe","suporte":"General_suporte__lnfGh"};